module.exports = "<md-dialog flex=\"80\">\n  <md-toolbar class=\"md-toolbar-tools\">\n    <md-icon>add</md-icon>\n    <h4>Create new contract</h4>\n\n    <span flex></span>\n    <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n      <md-icon aria-label=\"Close dialog\">close</md-icon>\n    </md-button>\n  </md-toolbar>\n  <stepper\n    confirm=\"$ctrl.confirm\"\n    steps=\"$ctrl.contractSteps\"\n    events=\"$ctrl.stepperEvents\"\n    stepper-model=\"$ctrl.contract\"\n  ></stepper>\n</md-dialog>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/corporate/contractDialog/contractDialog.html
// module id = 1080
// module chunks = 0